import React, { ReactNode } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";

type MainLayoutProps = {
  children: ReactNode;
};

const MainLayout: React.FC<MainLayoutProps> = ({ children }) => {
  return (
    <div className="min-h-screen flex flex-col font-sans">
      {/* ✅ Header always visible */}
      <Header />

      {/* ✅ Page content */}
      <main className="flex-1">{children}</main>

      {/* ✅ Footer always visible */}
      <Footer />
    </div>
  );
};

export default MainLayout;
